import { render, staticRenderFns } from "./TagCellType.vue?vue&type=template&id=fecaf226&"
import script from "./TagCellType.vue?vue&type=script&lang=ts&"
export * from "./TagCellType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports